export enum ReportErrorOrigin {
    GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA',
}

export interface ReportError {
    type: ReportErrorOrigin,
    detail: any,
}